import { Progress, Tooltip } from 'antd'
import classNames from 'classnames'
import { useRef } from 'react'
import styles from './capture-button.module.scss'

type Props = {
  onClick?: () => void
  onFileSelect?: (file: File) => void
  disabled?: boolean
  loading?: boolean
  progress?: number
}

export const CaptureButton = ({
  onClick,
  onFileSelect,
  disabled = false,
  loading = false,
  progress,
}: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const isDisabled = disabled || loading

  const getTooltipTitle = () => {
    if (loading) return 'Capturing image...'
    if (disabled) return 'Select a procedure to capture an image'
    return 'Capture image'
  }

  const handleClick = () => {
    if (onFileSelect) {
      fileInputRef.current?.click()
    } else if (onClick) {
      onClick()
    }
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file && onFileSelect) {
      onFileSelect(file)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  return (
    <div className={styles.container}>
      {onFileSelect && (
        <input
          ref={fileInputRef}
          type='file'
          accept='image/*'
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      )}
      <Tooltip title={getTooltipTitle()}>
        <button
          className={classNames(styles.captureButton, {
            [styles.disabled]: isDisabled,
            [styles.loading]: loading,
          })}
          onClick={handleClick}
          disabled={isDisabled}>
          {loading ? (
            <Progress
              type='circle'
              percent={progress || 0}
              width={40}
              showInfo={false}
              strokeColor='#1890ff'
              trailColor='#f5f5f5'
              status={progress === 100 ? 'success' : 'active'}
            />
          ) : (
            <div className={styles.innerCircle} />
          )}
        </button>
      </Tooltip>
    </div>
  )
}
